// The editor stores paragraph spacing as an empty Quill line. Imported articles
// often contain consecutive text paragraphs without that line.
export function spaceArticleParagraphs(html) {
  if (typeof html !== 'string' || !html) return html
  const root = document.createElement('div')
  root.innerHTML = html
  let changed = false
  const isTextParagraph = el => el && el.tagName === 'P' &&
    el.textContent.replace(/\u00a0/g, ' ').trim() &&
    !el.querySelector('img,video,audio,iframe,svg,object') &&
    !el.className.match(/(?:^|\s)art-/)
  const edgeBreak = (el, end) => {
    const nodes = Array.from(el.childNodes).filter(n => n.nodeType !== 8 &&
      !(n.nodeType === 3 && !n.textContent.trim()))
    const node = end ? nodes[nodes.length - 1] : nodes[0]
    return node && (node.nodeName === 'BR' ||
      (node.nodeType === 1 && edgeBreak(node, end)))
  }
  function visit(parent) {
    Array.from(parent.children).forEach(el => {
      // Leave captions, tables, lists and special article blocks alone.
      if (el.tagName === 'DIV' && !el.className.match(/(?:^|\s)art-/)) visit(el)
      if (!isTextParagraph(el)) return
      let next = el.nextSibling
      while (next && (next.nodeType === 8 || (next.nodeType === 3 && !next.textContent.trim()))) next = next.nextSibling
      if (!isTextParagraph(next) || edgeBreak(el, true) || edgeBreak(next, false)) return
      const blank = document.createElement('p')
      blank.appendChild(document.createElement('br'))
      parent.insertBefore(blank, next)
      changed = true
    })
  }
  visit(root)
  return changed ? root.innerHTML : html
}
